module.exports = __webpack_public_path__ + "assets/683aec580ac63bb8dff0ae8737737aed.mp3";